var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateAccountLineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.879 39.7002C47.879 41.9893 46.0104 44.1963 42.6814 45.8607C39.3823 47.5103 34.7897 48.545 29.6895 48.545C24.5893 48.545 19.9967 47.5103 16.6976 45.8607C13.3687 44.1963 11.5 41.9893 11.5 39.7002C11.5 37.4112 13.3687 35.2042 16.6976 33.5397C19.9967 31.8902 24.5893 30.8555 29.6895 30.8555C34.7897 30.8555 39.3823 31.8902 42.6814 33.5397C46.0104 35.2042 47.879 37.4112 47.879 39.7002Z",
    fill: "white",
    stroke: "#FFAE41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5398 22.3496C42.5398 29.4463 36.7868 35.1993 29.6902 35.1993C22.5935 35.1993 16.8405 29.4463 16.8405 22.3496C16.8405 15.253 22.5935 9.5 29.6902 9.5C36.7868 9.5 42.5398 15.253 42.5398 22.3496Z",
    fill: "white",
    stroke: "#FFAE41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0714 41.2293H35.25V37.196H41.0714H41.3214V36.946V31.5293H45.6786V36.946V37.196H45.9286H51.75V41.2293H45.9286H45.6786V41.4793V48.0293H41.3214V41.4793V41.2293H41.0714Z",
    fill: "white",
    stroke: "#FDAB29",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59C46.0163 59 59 46.0163 59 30C59 13.9837 46.0163 1 30 1C13.9837 1 1 13.9837 1 30C1 46.0163 13.9837 59 30 59Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccountLineWhite);
export default __webpack_public_path__ + "static/media/create-account-line-white.af534e84172f9de6c8328e90c2ac0362.svg";
export { ForwardRef as ReactComponent };